exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".footer-centered{justify-content:space-between;padding-left:0;padding-right:0}.modal-title{font-family:Open Sans;margin-bottom:1.5rem}.modal-body{padding:0}.modal-header{margin:0;padding:0;border-bottom:0}.modal-content{padding:2.5rem}.modal-footer{border-top:0}.modal-footer .btn-group{margin-top:inherit}.btn-group{justify-content:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["./~/bootstrap/scss/_functions.scss","./~/bootstrap/scss/_variables.scss","./src/main/webapp/content/scss/variables.scss"]}!./src/main/webapp/app/shared/components/draft-modal/draft-modal.component.scss
// module id = 728
// module chunks = 0